export default "__VITE_ASSET__22ca98ea__"